import { runInAction } from 'mobx';
import React, { useEffect, useMemo } from 'react';
import { useStore } from '../../store/Store';
import { observer } from 'mobx-react-lite';
import { basedAxios as axios } from '../../store/Store';

const SystemLabel = observer(({ name, groupName = 'Cms.Content', textOnly = false }: { name?: string; groupName?: string; textOnly?: boolean }) => {
  const store = useStore();
  const { lang } = store.environment;
  const label = useMemo(() => {
    if (name && store?.systemLabels?.[groupName]) return store?.systemLabels?.[groupName]?.[name.toUpperCase()];
  }, [store?.systemLabels?.[groupName], name]);
  useEffect(() => {
    if (typeof store.systemLabels[groupName] !== 'object' && store.systemLabels[groupName] !== 'Loading') {
      getGroup();
    }
  }, [store.systemLabels[groupName], name]);

  async function getGroup() {
    runInAction(() => {
      store.systemLabels[groupName] = 'Loading';
    });
    try {
      const { data } = await axios.get(`./systemLabel/group/?groupName=${groupName}&languageCode=${lang}`);
      runInAction(() => {
        const groups = { ...store.systemLabels };
        const groupData = data?.reduce((acc, curr) => {
          acc[curr.name.toUpperCase()] = curr;
          return acc;
        }, {});
        groups[groupName] = groupData;
        store.systemLabels = groups;
      });
    } catch (error) {
      console.error('Failed to get group:', error);
    }
  }
  if (textOnly) return label || label === 'Loading' ? label.value : `#${name}#`;
  if (!label || label === 'Loading') return <span>{`#${name}#`}</span>;
  return <span style={{ display: 'flex', alignItems: 'center' }}>{label.value}</span>;
});
export default SystemLabel;
